import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { format } from 'date-fns';
import { Trash } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from "firebase/firestore"; 
import { storage } from "../firebase/firebaseConfig";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";

const EditEvent = () => {
    const navigate = useNavigate();
    const { eventTitle } = useParams();

    const timestampToDate = (timestamp) => {
      const seconds = timestamp.seconds;
      const nanoseconds = timestamp.nanoseconds;
      return new Date(seconds * 1000 + nanoseconds / 1000000);
    };

    const [eventId, setEventId] = useState([]);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [featuredImage, setFeaturedImage] = useState(null);
    const [repeat, setRepeat] = useState("Do Not Repeat");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [eventType, setEventType] = useState("Free Event");
    const [publicType, setPublicType] = useState("");
    const [locationType, setLocationType] = useState("");
    const [location, setLocation] = useState("");
    const [registrationForm, setRegistrationForm] = useState("");
    const [featuredImageChange, setFeaturedImageChange] = useState(false);
    const [formsData, setFormsData] = useState([]);
    const [cancelled, setCancelled] = useState(false);

    useEffect(() => {
        const fetchEventsData = async () => {
            try {
            const querySnapshot = await getDocs(collection(db, "Events Calendar"));
            const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            for (let key in documents) {
              if (documents.hasOwnProperty(key)) {
                if (documents[key].Title === eventTitle) {
                    setEventId(documents[key].id);
                    setTitle(documents[key].Title);
                    setDescription(documents[key].Description);
                    setFeaturedImage(documents[key].FeaturedImage);
                    setRepeat(documents[key].Repeat);

                    documents[key].StartDateTime = timestampToDate(documents[key].StartDateTime); 
                    documents[key].EndDateTime = timestampToDate(documents[key].EndDateTime); 
                    setStartDate(format(documents[key].StartDateTime, "yyyy-MM-dd"));
                    setEndDate(format(documents[key].EndDateTime, "yyyy-MM-dd"));
                    setStartTime(format(documents[key].StartDateTime, "HH:mm"));
                    setEndTime(format(documents[key].EndDateTime, "HH:mm"));

                    setEventType(documents[key].EventType);
                    setPublicType(documents[key].PublicRegistration);
                    setLocationType(documents[key].LocationType);
                    setLocation(documents[key].Location);
                    setRegistrationForm(documents[key].RegistrationForm);
                    setCancelled(documents[key].Cancelled);
                }
              }
            }
            } catch (error) {
            console.error("Error fetching data: ", error);
            }
        };
        
        const fetchFormsData = async () => {
            try {
            const querySnapshot = await getDocs(collection(db, "Forms"));
            const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setFormsData(documents);
            console.log(documents)
            } catch (error) {
            console.error("Error fetching data: ", error);
            }
        };
    
        fetchEventsData();
        fetchFormsData();
    }, [eventTitle]);

    const handleImageChange = (e) => {
      const file = e.target.files[0];
      setFeaturedImage(URL.createObjectURL(file));
    };

    const updateEvent = async (e) => {
        e.currentTarget.innerHTML = "Updating Event...";
        e.target.style.cursor = "wait";
    
        const dateTimeStringStart = `${startDate}T${startTime}:00`; 
        const dateTimeStringEnd = `${endDate}T${endTime}:00`; 
    
        const dateTimeStart = new Date(dateTimeStringStart);
        const dateTimeEnd = new Date(dateTimeStringEnd);
    
        try {
            if (featuredImageChange)  {
                const imageUrl = await uploadImage();
    
                await setDoc(doc(db, `Events Calendar/${eventId}`), {
                  Title: title,
                  Description: description,
                  FeaturedImage: imageUrl,
                  Repeat: repeat,
                  StartDateTime: dateTimeStart,
                  EndDateTime: dateTimeEnd,
                  EventType: eventType,
                  PublicRegistration: publicType,
                  LocationType: locationType,
                  Location: location,
                  RegistrationForm: registrationForm,
                  Cancelled: cancelled
                });
          
                console.log("Event successfully updated!");
            } else {
                await setDoc(doc(db, `Events Calendar/${eventId}`), {
                  Title: title,
                  Description: description,
                  FeaturedImage: featuredImage,
                  Repeat: repeat,
                  StartDateTime: dateTimeStart,
                  EndDateTime: dateTimeEnd,
                  EventType: eventType,
                  PublicRegistration: publicType,
                  LocationType: locationType,
                  Location: location,
                  RegistrationForm: registrationForm,
                  Cancelled: cancelled
                });
          
                console.log("Event successfully updated!");
            }
    
        } catch (error) {
          console.error("Error updating event: ", error);
        }
    
        navigate('/events-calendar');
    };

    const generateId = () => {
      return [...Array(20)].map(() => Math.random().toString(36)[2]).join('');
    };

    const uploadImage = () => {
      return new Promise((resolve, reject) => {
        const imageRef = storageRef(storage, `${generateId()}`);
  
        uploadBytes(imageRef, featuredImage)
          .then((snapshot) => {
            console.log("Image uploaded successfully");
  
            getDownloadURL(snapshot.ref)
              .then((url) => {
                console.log("Download URL: ", url);
                resolve(url); 
              })
              .catch((error) => {
                console.error("Error getting download URL: ", error);
                reject(error); 
              });
          })
          .catch((error) => {
            console.error("Error uploading image: ", error);
            reject(error); 
          });
      });
    };

    const deleteEvent = async(e) => {
      e.currentTarget.innerHTML = "Cancelling Event...";
      e.target.style.cursor = "wait";
    
      const dateTimeStringStart = `${startDate}T${startTime}:00`; 
      const dateTimeStringEnd = `${endDate}T${endTime}:00`; 
  
      const dateTimeStart = new Date(dateTimeStringStart);
      const dateTimeEnd = new Date(dateTimeStringEnd);

      if (featuredImageChange)  {
        const imageUrl = await uploadImage();
        await setDoc(doc(db, `Events Calendar/${eventId}`), {
          Title: title,
          Description: description,
          FeaturedImage: imageUrl,
          Repeat: repeat,
          StartDateTime: dateTimeStart,
          EndDateTime: dateTimeEnd,
          EventType: eventType,
          PublicRegistration: publicType,
          LocationType: locationType,
          Location: location,
          RegistrationForm: registrationForm,
          Cancelled: true,
      });
      } else {
          await setDoc(doc(db, `Events Calendar/${eventId}`), {
            Title: title,
            Description: description,
            FeaturedImage: featuredImage,
            Repeat: repeat,
            StartDateTime: dateTimeStart,
            EndDateTime: dateTimeEnd,
            EventType: eventType,
            PublicRegistration: publicType,
            LocationType: locationType,
            Location: location,
            RegistrationForm: registrationForm,
            Cancelled: true,
          });
    
          console.log("Event successfully updated!");
      }
    
      navigate('/events-calendar');
    }

    const undoCancel = async(e) => {
      e.currentTarget.innerHTML = "Cancelling Event...";
      e.target.style.cursor = "wait";
    
      const dateTimeStringStart = `${startDate}T${startTime}:00`; 
      const dateTimeStringEnd = `${endDate}T${endTime}:00`; 
  
      const dateTimeStart = new Date(dateTimeStringStart);
      const dateTimeEnd = new Date(dateTimeStringEnd);

      if (featuredImageChange)  {
        const imageUrl = await uploadImage();
        await setDoc(doc(db, `Events Calendar/${eventId}`), {
          Title: title,
          Description: description,
          FeaturedImage: imageUrl,
          Repeat: repeat,
          StartDateTime: dateTimeStart,
          EndDateTime: dateTimeEnd,
          EventType: eventType,
          PublicRegistration: publicType,
          LocationType: locationType,
          Location: location,
          RegistrationForm: registrationForm,
          Cancelled: false,
      });
      } else {
          await setDoc(doc(db, `Events Calendar/${eventId}`), {
            Title: title,
            Description: description,
            FeaturedImage: featuredImage,
            Repeat: repeat,
            StartDateTime: dateTimeStart,
            EndDateTime: dateTimeEnd,
            EventType: eventType,
            PublicRegistration: publicType,
            LocationType: locationType,
            Location: location,
            RegistrationForm: registrationForm,
            Cancelled: false,
          });
    
          console.log("Event successfully updated!");
      }
    
      navigate('/events-calendar');
    }

    return (
        <div id='content'>
        <h1>Edit Event: {eventTitle}</h1>
          <div className='row'>
            <div className='col-sm-8'>
              <div className='ev-basic-info'>
                <h4>Basic Info</h4>
                <label>Event Title
                <br/> <input type="text" value={title} 
                onChange={(e) => setTitle(e.target.value)}
                /></label>
                <label>Event Description
                <br/> <textarea value={description} 
                onChange={(e) => setDescription(e.target.value)}
                /></label>
                <label className='checkbox-label'><input type="checkbox" value={publicType} 
                onChange={(e) => setPublicType(e.target.value)}
                /> Public Registration</label>
                <select value={eventType}
                onChange={(e) => setEventType(e.target.value)}
                >
                  <option value="Free Event">Free Event</option>
                  <option value="Paid Event">Paid Event</option>
                </select>
              </div>
              <br/>
              <h4>Date & Time</h4>
              <div className='row'>
                <div className='col-sm-3'>
                  <label>Start Date
                  <br/> <input type="date" value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  /></label>
                </div>
                <div className='col-sm-3'>
                  <label>Start Time
                  <br/> <input type="time"  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  /></label>
                </div>
                <div className='col-sm-3'>
                  <label>End Date
                  <br/> <input type="date" value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  /></label>
                </div>
                <div className='col-sm-3'>
                  <label>End Time
                  <br/> <input type="time" value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  /></label>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-3'>
                </div>
                <div className='col-sm-3'>
                </div>
                <div className='col-sm-3'>
                </div>
                <div className='col-sm-3'>
                  <select value={repeat}
                  onChange={(e) => setRepeat(e.target.value)}
                  >
                    <option value="Do Not Repeat">Do Not Repeat</option>
                    <option value="Repeat Every Week">Repeat Every Week</option>
                    <option value="Repeat Every Day">Repeat Every Day</option>
                  </select>
                </div>
              </div>
              <br/>
              <h4>Location</h4>
              <label className='checkbox-label'><input type="checkbox" value={locationType}
              onChange={(e) => setLocationType(e.target.value)}
              /> Online Event</label>
              <label>Address/Online Link <input type="text" value={location}
              onChange={(e) => setLocation(e.target.value)}
              /></label>
            </div>
            <div className='col-sm-4' style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
              <div>
                <img src={featuredImage} width="95%"/>
                <label style={{ cursor: 'pointer' }}  htmlFor="file-upload" className="custom-file-upload">
                  <b>Change Featured Image</b>
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleImageChange}
                  style={{ display: 'none' }} 
                />
              <br/>
              <br/>
                <h4>Registration</h4>
                <label>Register Form</label>
                <select value={registrationForm} onChange={(e) => setRegistrationForm(e.target.value)}>
                  <option value="None">None</option>
                  {formsData.map((item, index) => (
                    <option key={index} value={item.Title}>{item.Title}</option>
                  ))}
                </select>
              </div>
              <br/>
              <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'space-around'}}>
                <button 
                onClick={(e) => updateEvent(e)}
                >Update Event</button>
                {cancelled ? <button onClick={(e) => undoCancel(e)}>Undo Cancel</button> : <button onClick={(e) => deleteEvent(e)}>Cancel Event</button>}
              </div>
            </div>
          </div>
      </div>
    );
}

export default EditEvent;
